import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { Input, InputRef } from 'antd';
import { PasswordProps } from 'antd/es/input';
import React from 'react';

export type PasswordInputProps<T extends FieldValues> = UseControllerProps<T> &
  PasswordProps;

export const PasswordInput = React.forwardRef<InputRef, PasswordInputProps<any>>(({
  name,
  placeholder,
  className,
  ...props
}, ref) => {
  const {
    field: { onChange, onBlur, value },
  } = useController({ name });

  return (
    <Input.Password
      ref={ref}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
  );
});

PasswordInput.displayName = 'PasswordInput';
